import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { wrapCreateMemoryRouter } from '@sentry/react';
import {
    createBrowserRouter,
    Navigate,
    RouteObject,
    RouterProvider,
} from 'react-router-dom';
import { OperatorAppRoutes } from '../config/OperatorRoutingConfig.tsx';
import { css } from '@emotion/css';
import { CssBaseline } from '@mui/material';
import { OperatorThemeProvider } from './OperatorThemeProvider.tsx';
import { BaseData, BaseLayoutAndData } from './BaseLayoutAndData.tsx';
import { AlternativeLanding } from '../../landing-page/AlternativeLanding.tsx';
import { ResetPassword } from '../../reset-password/ResetPassword.tsx';
import {
    ConnectedChangePasswordController,
    PasswordChangeTokenSource,
} from '../../password-change-token/ChangePasswordController.tsx';
import { OperatorMasterData } from '../../operator-master-data/components/OperatorMasterData.tsx';
import {
    LanguageProvider,
    Localized,
} from 'dg-web-shared/lib/Localization.tsx';
import { Zones, ZonesTab } from '../../zones/components/Zones.tsx';
import { ZonesDetail } from '../../zones/components/ZonesDetail.tsx';
import { Parkings, ParkingsTab } from '../../parkings/components/Parkings.tsx';
import { OperatorCheckinStatisticsRoute } from '../../statistics/OperatorCheckinStatisticsRoute.tsx';
import {
    OperatorParkingaboAddUser,
    OperatorParkingaboInviteUser,
    OperatorParkingaboUsers,
} from '../../parkingabo-users/OperatorParkingaboUsers.tsx';
import {
    OperatorProductDetail,
    OperatorProducts,
} from '../../products/OperatorProducts.tsx';
import { TomsOverview } from '../../tom/components/TomsOverview.tsx';
import { UsbSticks } from '../../usb-sticks/components/UsbSticks.tsx';
import * as SettingsState from '../../common/state/SettingsState.ts';
import { StateSlice } from '../../common/state/SettingsState.ts';
import { IFrame } from './IFrame.tsx';
import { ClearancePermitList } from '../../clearance-permit-list/components/ClearancePermitList.tsx';
import { ClearanceRequests } from '../../clearance-requests/ClearanceRequests.tsx';
import { ActivityStatement } from '../../activity-statement/components/ActivityStatement.tsx';
import { CustomerAccounts } from '../../customer-account/components/CustomerAccounts.tsx';
import { OperatorParkingaboUsersProductsAdd } from '../../parkingabo-users/OperatorParkingaboUsersProductsAdd.tsx';
import { OperatorParkingaboUsersDetails } from '../../parkingabo-users/OperatorParkingaboUsersDetail.tsx';
import {
    OperatorParkingaboUsersVehicleAddForm,
    OperatorParkingaboUsersVehicleEditForm,
} from '../../parkingabo-users/OperatorParkingaboUsersVehicleForm.tsx';
import {
    OperatorParkingaboUserProductDetail,
    OperatorParkingaboUsersProducts,
} from '../../parkingabo-users/OperatorParkingaboUsersProducts.tsx';
import * as AuthenticationState from '../state/AuthenticationState.ts';
import { Spinner } from '../../ui/loaders/Spinner.tsx';
import { LandingPage } from '../../landing-page/LandingPage.tsx';
import { ReactNode, useMemo } from 'react';
import { OperatorProductTypes } from '../../product-types/OperatorProductTypes.tsx';
import { OperatorProductTypesDetailModal } from '../../product-types/OperatorProductTypesDetailModal.tsx';
import { OperatorQuotasDetail } from '../../quotas/OperatorQuotasDetail.tsx';
import { OperatorParkingaboUserEditForm } from '../../parkingabo-users/OperatorParkingaboUsersForm.tsx';
import { OperatorParkingaboUsersVehicles } from '../../parkingabo-users/OperatorParkingaboUsersVehicles.tsx';
import { OperatorParkingaboUsersAccountStatement } from '../../parkingabo-users/OperatorParkingaboUsersAccountStatement.tsx';
import { OperatorOffstreetTransactionTicket } from '../../offstreet-transactions/OperatorOffstreetTransactionTicket.tsx';
import { OperatorOffstreetTransactionEntryWithoutExit } from '../../offstreet-transactions/OperatorOffstreetTransactionEntryWithoutExit.tsx';
import { OperatorOffstreetTransactionContract } from '../../offstreet-transactions/OperatorOffstreetTransactionContract.tsx';
import { OperatorOffstreetTransactionsRouteLayout } from '../../offstreet-transactions/OperatorOffstreetTransactionsRoute.tsx';
import { PermitTypes } from '../../permit-types/components/PermitTypes.tsx';
import { SpecialReports } from '../../special-reports/SpecialReports.tsx';
import {
    PeripheriesOverviewDesktop,
    PeripheriesOverviewMobile,
} from '../../cloud-connector/CloudConnectorPeripheriesOverview.tsx';
import { MobileLoginPage } from '../../mobile/login-page/MobileLoginPage.tsx';
import { MobileLayout } from './MobileLayout.tsx';
import { MobileHomePage } from '../../mobile/HomePage.tsx';
import { ParkingPortalSettings } from '../../mobile/ParkingPortalSettings.tsx';
import {
    AccessDetails,
    PayStationDetailsLayout,
    PayStationDetailsTab,
    PeripheryDetailsLayout,
    PeripheryDetailWrapper,
} from '../../cloud-connector/CloudConnectorPeripheriesDetail.tsx';
import { PayStationStatements } from '../../cloud-connector/pay-station/PayStationStatements.tsx';
import { PayStationCollections } from '../../cloud-connector/pay-station/PayStationCollections.tsx';
import { PeripheryHistory } from '../../periphery-history/PeripheryHistory.tsx';
import { CloudConnectorRecoder } from '../../cloud-connector/CloudConnectorRecoder.tsx';
import { CloudConnectorRecodeEntryWithoutExit } from '../../cloud-connector/CloudConnectorRecodeEntryWithoutExit.tsx';
import { CloudConnectorRecodeEntryWithoutExitCondition } from '../../cloud-connector/CloudConnectorRecodeEntryWithoutExitCondition.tsx';
import {
    CloudConnectorRecodeEntryWithoutExitByIdConditionsOutlet,
    CloudConnectorRecodeLicensePlateConditions,
    CloudConnectorRecodeTicketScanConditionsOutlet,
    CloudConnectorRecodeTicketScanQrConditionsOutlet,
} from '../../cloud-connector/CloudConnectorRecodeEntryWithoutExitConditionsOutlet.tsx';
import { ParkingportalPrivacy } from '../../privacy/Privacy.tsx';
import {
    CloudConnectorRecodeErrorResponse,
    CloudConnectorRecodeSuccessResponse,
} from '../../cloud-connector/CloudConnectorRecodeResponse.tsx';
import { CloudConnectorCounterOverview } from '../../cloud-connector/CloudConnectorCounterOverview.tsx';
import { PayStationManualCorrection } from '../../cloud-connector/pay-station/PayStationManualCorrection.tsx';
import { CloudConnectorCounterDetail } from '../../cloud-connector/CloudConnectorCounterDetail.tsx';
import {
    CloudConnectorGenerateGuestPermit,
    GuestPermitGenerationErrorModal,
    GuestPermitGenerationSuccessModal,
} from '../../cloud-connector/CloudConnectorGenerateGuestPermit.tsx';
import { PeripheriesOverviewFullscreen } from '../../cloud-connector/CloudConnectorPeripheriesFullscreenOverview.tsx';
import { OtpCheck, OtpErrorModal } from '../../landing-page/OtpCheck.tsx';
import { ConfirmOtpModal } from '../../operator-logins/components/ConfirmOtpModal.tsx';
import { OperatorQuotasReduction } from '../../quotas/OperatorQuotasReduction.tsx';
import { CloudConnectorRecodeQrCodes } from '../../cloud-connector/CloudConnectorRecodeQrCodes.tsx';
import { CloudConnectorRecodeQrCodesAdd } from '../../cloud-connector/CloudConnectorRecodeQrCodesAdd.tsx';
import { OperatorPermitStatisticsRoute } from '../../statistics/OperatorPermitStatisticsRoute.tsx';
import { OperatorQuotasOverview } from '../../quotas/OperatorQuotasOverview.tsx';
import { OperatorOffstreetEvents } from '../../offstreet-events/OperatorOffstreetEvents.tsx';
import { OperatorOffstreetEventsAdd } from '../../offstreet-events/OperatorOffstreetEventsAdd.tsx';
import { OperatorOffstreetEventCards } from '../../offstreet-events/OperatorOffstreetEventCards.tsx';
import { OperatorOffstreetEventsAddStack } from '../../offstreet-events/OperatorOffstreetEventsAddStack.tsx';
import { OperatorOffstreetTransactionTicketLost } from '../../offstreet-transactions/OperatorOffstreetTransactionTicketLost.tsx';
import { PeripheryDetailTab } from '../../cloud-connector/CloudConnectorPeripheryDetailTabStatus.tsx';
import { PeripheryPresenceTab } from '../../cloud-connector/CloudConnectorPeripheryDetailTabPresence.tsx';
import { CloudConnectorPeripheryType } from 'dg-web-shared/model/CloudConnector.ts';
import { PeripheryPaymentsTab } from '../../cloud-connector/CloudConnectorPeripheriesPayments.tsx';
import { OperatorOffstreetEventEditStack } from '../../offstreet-events/OperatorOffstreetEventEditStack.tsx';
import { TariffsOverview } from '../../tariffs/components/TariffsOverview.tsx';
import { TariffDetails } from '../../tariffs/components/TariffDetails.tsx';
import { OperatorOffstreetEventsEdit } from '../../offstreet-events/OperatorOffstreetEventsEdit.tsx';
import { OperatorParkingaboUsersTransactions } from '../../parkingabo-users/OperatorParkingaboUsersTransactions.tsx';
import { NoAccessDialogRoute } from '../../operator-logins/components/NoAccessDialog.tsx';
import { CloudConnectorRecodeStatements } from '../../cloud-connector/CloudConnectorRecodeStatements.tsx';
import { CloudConnectorSmartCallProfilesTab } from '../../cloud-connector/CloudConnectorSmartCallProfilesTab.tsx';
import { CloudConnectorSmartCallWeeklyPlanTab } from '../../cloud-connector/CloudConnectorSmartCallWeeklyPlanTab.tsx';
import { CloudConnectorSmartCall } from '../../cloud-connector/CloudConnectorSmartCall.tsx';
import {
    CloudConnectorSmartCallProfileAdd,
    CloudConnectorSmartCallProfileDetails,
} from '../../cloud-connector/CloudConnectorSmartCallProfileForm.tsx';
import {
    OperatorGuestProductDetail,
    OperatorGuestProducts,
} from '../../products/OperatorGuestProducts.tsx';
import {
    GuestReservationAddSuccess,
    OperatorGuestReservationAdd,
} from '../../products/OperatorGuestReservationAdd.tsx';
import { DownloadsOverview } from '../../operator-logins/components/DownloadsOverview.tsx';
import { CloudConnectorAutoRecode } from '../../cloud-connector/CloudConnectorAutoRecode.tsx';
import { CloudConnectorAutoRecodeCreate } from '../../cloud-connector/CloudConnectorAutoRecodeCreate.tsx';
import { CloudConnectorAutoRecodeEdit } from '../../cloud-connector/CloudConnectorAutoRecodeEdit.tsx';
import { ParkingsDetail } from '../../parkings/components/ParkingsDetail.tsx';
import { Language, languageFromString } from 'dg-web-shared/lib/Localized.ts';
import { CloudConnectorRecodeLicensePlateSerach } from '../../cloud-connector/CloudConnectorRecodeLicensePlateSerach.tsx';
import { OperatorOnstreetTransactionList } from '../../onstreet-transactions/OperatorOnstreetTransactionList.tsx';
import { OperatorOnstreetTransactionContractDetail } from '../../onstreet-transactions/OperatorOnstreetTransactionContractDetail.tsx';
import { OperatorGuestDayPassOverview } from '../../products/OperatorGuestDayPassOverview.tsx';
import { OperatorGuestDayPassAdd } from '../../products/OperatorGuestDayPassAdd.tsx';
import { PasswordPage } from '../../operator-logins/components/PasswordPage.tsx';
import {
    OperatorLoginDetail,
    OperatorLoginDetailContext,
    OperatorLoginDetailTab,
} from '../../operator-logins/components/OperatorLoginDetail.tsx';
import { OperatorLoginDetailCreate } from '../../operator-logins/components/OperatorLoginCreate.tsx';
import { OperatorLoginProfilePage } from '../../operator-logins/components/OperatorLoginProfilePage.tsx';
import { OperatorLogins } from '../../operator-logins/components/OperatorLoginsList.tsx';
import { OperatorParkingaboRoles } from '../../parkingabo-roles/OperatorParkingaboRoles.tsx';
import {
    OperatorSelectionDesktop,
    OperatorSelectionMobile,
} from './OperatorSelection.tsx';
import { OperatorExternalIdFallbackContextProvider } from './OperatorExternalIdFallbackContext.tsx';
import { CloudConnectorSmartCallIndividualDatesTab } from '../../cloud-connector/CloudConnectorSmartCallIndividualDatesTab.tsx';
import { EnforcementLogListComp } from '../../enforcement-log/EnforcementLogList.tsx';
import { EnforcementLogDetail } from '../../enforcement-log/EnforcementLogDetail.tsx';
import { PermitTypesDetail } from '../../permit-types/components/PermitTypesDetail.tsx';

const createSentryBrowserRouter = wrapCreateMemoryRouter(createBrowserRouter);

const publicRoutes = [
    {
        path: '/',
        element: <LandingPage />,
        children: [
            {
                path: 'otp',
                element: <OtpCheck />,
                children: [
                    {
                        path: 'error/:reason?',
                        element: <OtpErrorModal />,
                    },
                ],
            },
        ],
    },
    {
        path: '/reset-password',
        element: (
            <AlternativeLanding>
                <ResetPassword source={PasswordChangeTokenSource.WEB} />
            </AlternativeLanding>
        ),
    },
    {
        path: '/password-change-token',
        element: (
            <AlternativeLanding>
                <ConnectedChangePasswordController />
            </AlternativeLanding>
        ),
    },
    {
        path: '/:operatorExternalId/mobile/*',
        element: <Navigate to="/mobile/login" replace />,
        handle: {
            isMobile: true,
        },
    },
    {
        path: '/mobile',
        handle: {
            isMobile: true,
        },
        children: [
            {
                index: true,
                element: <Navigate to="login" replace />,
            },
            {
                path: '*',
                element: <Navigate to=".." replace />,
            },
            {
                path: 'login',
                element: <MobileLoginPage />,
                children: [
                    {
                        path: 'otp',
                        element: <OtpCheck />,
                        children: [
                            {
                                path: 'error/:reason?',
                                element: <OtpErrorModal />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'reset-password',
                element: (
                    <ResetPassword source={PasswordChangeTokenSource.MOBILE} />
                ),
            },
        ],
    },
    {
        path: '/privacy',
        element: <ParkingportalPrivacy />,
    },
    {
        path: '*',
        element: <Navigate to="/" replace />,
    },
];

function OperatourRouterProvider() {
    const { storeState } = useStore(s => ({
        settings: new SettingsState.StateSlice(s).state,
        authentication: new AuthenticationState.StateSlice(s).state,
    }));
    const { authentication } = storeState;

    if (authentication.status.unknown) {
        return <Spinner />;
    }

    if (authentication.status.unauthorized || authentication.status.unknown) {
        return (
            <RouterProvider
                key="public"
                router={createSentryBrowserRouter(publicRoutes)}
            />
        );
    }

    const authorizedRoutes = getAuthorizedRoutes({
        settings: storeState.settings,
        authentication: authentication.status,
    });
    return (
        <OperatorExternalIdFallbackContextProvider>
            <RouterProvider
                key="authorized"
                router={createSentryBrowserRouter([
                    {
                        path: '/select-operator',
                        element: <OperatorSelectionDesktop />,
                    },
                    {
                        path: '/mobile/select-operator',
                        element: <OperatorSelectionMobile />,
                    },
                    {
                        path: '/:operatorExternalId',
                        children: [authorizedRoutes],
                    },
                    authorizedRoutes,
                    {
                        path: '*',
                        element: <Navigate to="/" replace />,
                    },
                ])}
            />
        </OperatorExternalIdFallbackContextProvider>
    );
}

function getAuthorizedRoutes({
    settings,
    authentication,
}: {
    settings: SettingsState.State;
    authentication: AuthenticationState.AuthStatus;
}): RouteObject {
    const offstreetDevicesRoutes = [
        {
            path: 'parking/:zoneId/periphery/PAY_STATION/:onPremiseId',
            element: (
                <PeripheryDetailWrapper
                    peripheryType={CloudConnectorPeripheryType.PAY_STATION}
                    render={context => (
                        <PayStationDetailsLayout context={context} />
                    )}
                />
            ),
            handle: {
                routeName: OperatorAppRoutes.CloudConnectorPeripheriesDetail,
            },
            children: [
                {
                    path: 'payments',
                    element: <PeripheryPaymentsTab />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorPeripheryDetailPresence,
                    },
                },
                {
                    path: 'detail',
                    element: <PayStationDetailsTab />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorPeripheryDetailStatus,
                    },
                    children: [
                        {
                            path: 'coin-balance/:coinType/manual-correction',
                            element: <PayStationManualCorrection />,
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorPayStationManualCorrection,
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: 'parking/:zoneId/periphery/ACCESS/:onPremiseId/detail',
            element: (
                <PeripheryDetailWrapper
                    peripheryType={CloudConnectorPeripheryType.ACCESS}
                    render={context => <AccessDetails context={context} />}
                />
            ),
            handle: {
                routeName: OperatorAppRoutes.CloudConnectorPeripheriesDetail,
            },
        },
        {
            path: 'parking/:zoneId/periphery/:peripheryType/:onPremiseId',
            element: (
                <PeripheryDetailWrapper
                    render={context => (
                        <PeripheryDetailsLayout context={context} />
                    )}
                />
            ),
            handle: {
                routeName: OperatorAppRoutes.CloudConnectorPeripheriesDetail,
            },
            children: [
                {
                    path: 'presence',
                    element: <PeripheryPresenceTab />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorPeripheryDetailPresence,
                    },
                },
                {
                    path: 'payments',
                    element: <PeripheryPaymentsTab />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorPeripheryDetailPresence,
                    },
                },
                {
                    path: 'detail',
                    element: <PeripheryDetailTab />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorPeripheryDetailStatus,
                    },
                },
            ],
        },
    ];

    const onstreetTransactionsDetailRoutes = [
        {
            path: 'contract/:contractExternalId',
            element: <OperatorOnstreetTransactionContractDetail />,
            handle: {
                routeName: OperatorAppRoutes.OnstreetTransactionsContractDetail,
            },
        },
    ];

    const offstreetTransactionsDetailRoutes = [
        {
            path: 'ticket/:ticketId/detail',
            element: <OperatorOffstreetTransactionTicket />,
            handle: {
                routeName: OperatorAppRoutes.OffstreetTransactionsTicketDetail,
            },
        },
        {
            path: 'ticket-lost/:payStationPaymentId/detail',
            element: <OperatorOffstreetTransactionTicketLost />,
            handle: {
                routeName:
                    OperatorAppRoutes.OffstreetTransactionsTicketLostDetail,
            },
        },
        {
            path: 'entry-without-exit/:entryWithoutExitId/detail',
            element: <OperatorOffstreetTransactionEntryWithoutExit />,
            handle: {
                routeName:
                    OperatorAppRoutes.OffstreetTransactionsEntryWithoutExitDetail,
            },
            children: [
                {
                    path: 'guest-permit-success/:contractExternalId',
                    element: <GuestPermitGenerationSuccessModal />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorGenerateGuestPermitSuccess,
                    },
                },
                {
                    path: 'recode',
                    element: (
                        <CloudConnectorRecodeEntryWithoutExitByIdConditionsOutlet />
                    ),
                    children: [
                        {
                            index: true,
                            element: <CloudConnectorRecodeEntryWithoutExit />,
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExit,
                            },
                        },
                        {
                            path: 'recodeCondition/:recodeConditionId',
                            element: (
                                <CloudConnectorRecodeEntryWithoutExitCondition />
                            ),
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExitCondition,
                            },
                        },
                    ],
                },
                {
                    path: 'success',
                    element: <CloudConnectorRecodeSuccessResponse />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorRecodeSuccessResponse,
                    },
                },
                {
                    path: 'error/:type?',
                    element: <CloudConnectorRecodeErrorResponse />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorRecodeErrorResponse,
                    },
                },
                {
                    path: 'guest-permit',
                    element: <CloudConnectorGenerateGuestPermit />,
                    handle: {
                        routeName:
                            OperatorAppRoutes.CloudConnectorGenerateGuestPermit,
                    },
                    children: [
                        {
                            path: 'error',
                            element: <GuestPermitGenerationErrorModal />,
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorGenerateGuestPermitError,
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: 'contract/:contractExternalId/detail',
            element: <OperatorOffstreetTransactionContract />,
            handle: {
                routeName:
                    OperatorAppRoutes.OffstreetTransactionsContractDetail,
            },
        },
    ];

    const zonesDetailRoutes = [
        {
            path: ':zoneId',
            element: <ZonesDetail />,
            handle: { routeName: OperatorAppRoutes.ZonesDetail },
        },
    ];

    const parkingsDetailRoutes = [
        {
            path: ':zoneId',
            element: <ParkingsDetail />,
            handle: { routeName: OperatorAppRoutes.ParkingsDetail },
            children: [
                {
                    path: 'smart-call',
                    element: <CloudConnectorSmartCall />,
                    handle: {
                        routeName: OperatorAppRoutes.CloudConnectorSmartCall,
                    },
                    children: [
                        {
                            path: 'profiles',
                            element: <CloudConnectorSmartCallProfilesTab />,
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorSmartCallProfiles,
                            },
                            children: [
                                {
                                    path: 'add',
                                    element: (
                                        <CloudConnectorSmartCallProfileAdd />
                                    ),
                                    handle: {
                                        routeName:
                                            OperatorAppRoutes.CloudConnectorSmartCallProfileAdd,
                                    },
                                },
                                {
                                    path: ':profileId/details',
                                    element: (
                                        <CloudConnectorSmartCallProfileDetails />
                                    ),
                                    handle: {
                                        routeName:
                                            OperatorAppRoutes.CloudConnectorSmartCallProfileDetails,
                                    },
                                },
                            ],
                        },
                        {
                            path: 'weekly-plan',
                            element: <CloudConnectorSmartCallWeeklyPlanTab />,
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorSmartCallWeeklyPlan,
                            },
                        },
                        {
                            path: 'individual-dates',
                            element: (
                                <CloudConnectorSmartCallIndividualDatesTab />
                            ),
                            handle: {
                                routeName:
                                    OperatorAppRoutes.CloudConnectorSmartCallIndividualDates,
                            },
                        },
                    ],
                },
            ],
        },
    ];

    return {
        element: (
            <BaseData settings={settings} authentication={authentication} />
        ),
        children: [
            {
                path: 'offstreet-devices/fullscreen',
                element: <PeripheriesOverviewFullscreen />,
                handle: {
                    routeName:
                        OperatorAppRoutes.CloudConnectorPeripheriesFullscreen,
                },
                children: offstreetDevicesRoutes,
            },
            {
                element: <BaseLayoutAndData />,
                children: [
                    {
                        path: 'profile',
                        element: <OperatorLoginProfilePage />,
                        handle: {
                            routeName: OperatorAppRoutes.LoginProfile,
                        },
                        children: [
                            {
                                path: 'password',
                                element: <PasswordPage />,
                                handle: {
                                    routeName: OperatorAppRoutes.Password,
                                },
                            },
                            {
                                path: ':operatorLoginId/confirm-otp/:otpUrl',
                                element: <ConfirmOtpModal />,
                                handle: {
                                    routeName: OperatorAppRoutes.ConfirmOtp,
                                },
                            },
                        ],
                    },
                    {
                        path: 'downloads',
                        element: <DownloadsOverview />,
                        handle: {
                            routeName: OperatorAppRoutes.Downloads,
                        },
                    },
                    {
                        handle: {
                            title: (
                                <Localized
                                    de="Allgemein"
                                    fr="Général"
                                    en="Global"
                                    it="Generale"
                                />
                            ),
                        },
                        children: [
                            {
                                index: true,
                                element: <OperatorMasterData />,
                                handle: {
                                    routeName: OperatorAppRoutes.Home,
                                },
                            },
                            {
                                path: 'activity-statement',
                                element: <ActivityStatement />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ActivityStatement,
                                },
                            },
                            {
                                path: 'tariffs',
                                element: <TariffsOverview />,
                                handle: {
                                    routeName: OperatorAppRoutes.Tariffs,
                                },
                                children: [
                                    {
                                        path: ':tariffId',
                                        element: <TariffDetails />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.TariffDetails,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'quotas',
                                element: <OperatorQuotasOverview />,
                                handle: {
                                    routeName: OperatorAppRoutes.QuotasOverview,
                                },
                                children: [
                                    {
                                        path: ':contractQuotaPartitionId',
                                        element: <OperatorQuotasDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.QuotasDetail,
                                        },
                                        children: [
                                            {
                                                path: 'reduction',
                                                element: (
                                                    <OperatorQuotasReduction />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.QuotasReduction,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: 'logins',
                                element: <OperatorLogins />,
                                handle: {
                                    routeName: OperatorAppRoutes.Logins,
                                },
                                children: [
                                    {
                                        path: 'operator-login/:organizationLoginId',
                                        element: <OperatorLoginDetailContext />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.LoginDetail,
                                        },
                                        children: [
                                            {
                                                path: 'general',
                                                element: (
                                                    <OperatorLoginDetail
                                                        operatorLoginDetailTab={
                                                            OperatorLoginDetailTab.GENERAL
                                                        }
                                                    />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.LoginDetail,
                                                },
                                            },
                                            {
                                                path: 'detail',
                                                element: (
                                                    <OperatorLoginDetail
                                                        operatorLoginDetailTab={
                                                            OperatorLoginDetailTab.DETAIL
                                                        }
                                                    />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.LoginDetail,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: 'operator-login-create',
                                        element: <OperatorLoginDetailCreate />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.LoginCreate,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'check-in-statistics',
                                element: <OperatorCheckinStatisticsRoute />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.StatisticsCheckins,
                                },
                            },
                            {
                                path: 'permit-statistics',
                                element: <OperatorPermitStatisticsRoute />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.StatisticsPermits,
                                },
                            },
                        ],
                    },
                    {
                        handle: {
                            title: (
                                <Localized
                                    de="Onstreet"
                                    fr="Onstreet"
                                    en="Onstreet"
                                    it="Onstreet"
                                />
                            ),
                        },
                        children: [
                            {
                                path: 'onstreet-transactions',
                                element: <OperatorOnstreetTransactionList />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OnstreetTransactions,
                                },
                                children: onstreetTransactionsDetailRoutes,
                            },
                            {
                                path: 'enforcement-log',
                                element: <EnforcementLogListComp />,
                                handle: {
                                    routeName: OperatorAppRoutes.EnforcementLog,
                                },
                                children: [
                                    {
                                        path: ':enforcementLogId/detail',
                                        element: <EnforcementLogDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.EnforcementLogDetail,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'zones',
                                children: [
                                    {
                                        path: '',
                                        element: <Zones tab={ZonesTab.MAP} />,
                                        handle: {
                                            routeName: OperatorAppRoutes.Zones,
                                        },
                                        children: zonesDetailRoutes,
                                    },
                                    {
                                        path: 'list',
                                        element: <Zones tab={ZonesTab.LIST} />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ZonesList,
                                        },
                                        children: zonesDetailRoutes,
                                    },
                                ],
                            },
                            {
                                path: 'parking-meters',
                                element: <TomsOverview />,
                                handle: {
                                    routeName: OperatorAppRoutes.ParkingMeters,
                                },
                            },
                            {
                                path: 'usb-sticks',
                                element: <UsbSticks />,
                                handle: {
                                    routeName: OperatorAppRoutes.UsbSticks,
                                },
                            },
                        ],
                    },
                    {
                        handle: {
                            title: (
                                <Localized
                                    de="Offstreet"
                                    fr="Offstreet"
                                    en="Offstreet"
                                    it="Offstreet"
                                />
                            ),
                        },
                        children: [
                            {
                                path: 'offstreet-transactions',
                                element: (
                                    <OperatorOffstreetTransactionsRouteLayout />
                                ),
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OffstreetTransactions,
                                },
                                children: offstreetTransactionsDetailRoutes,
                            },
                            {
                                path: 'guest-products',
                                element: <OperatorGuestProducts />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OffstreetGuestProducts,
                                },
                                children: [
                                    {
                                        path: ':contractExternalId/detail',
                                        element: <OperatorGuestProductDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboProductsDetail,
                                        },
                                        children: [
                                            {
                                                path: 'add-success',
                                                element: (
                                                    <GuestReservationAddSuccess />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.OffstreetGuestReservationAddSuccess,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: 'add-guest-reservation',
                                        element: (
                                            <OperatorGuestReservationAdd />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetGuestReservationAdd,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'guest-day-pass-overview',
                                element: <OperatorGuestDayPassOverview />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OffstreetGuestDayPassOverview,
                                },
                                children: [
                                    {
                                        path: 'add',
                                        element: <OperatorGuestDayPassAdd />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetGuestDayPassAdd,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'offstreet-events',
                                element: <OperatorOffstreetEvents />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OffstreetEvents,
                                },
                                children: [
                                    {
                                        path: 'add',
                                        element: <OperatorOffstreetEventsAdd />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetEventsAdd,
                                        },
                                    },
                                    {
                                        path: ':eventId/edit',
                                        element: (
                                            <OperatorOffstreetEventsEdit />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetEventEdit,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'offstreet-events/:eventId',
                                element: <OperatorOffstreetEventCards />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.OffstreetEventCards,
                                },
                                children: [
                                    {
                                        path: 'stack/:stackId/edit',
                                        element: (
                                            <OperatorOffstreetEventEditStack />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetEventCardsEditStack,
                                        },
                                    },
                                    {
                                        path: 'stack/add',
                                        element: (
                                            <OperatorOffstreetEventsAddStack />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.OffstreetEventCardsAddStack,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'device-history',
                                element: <PeripheryHistory />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.PeripheryHistory,
                                },
                            },
                            {
                                path: 'pay-station-statement',
                                element: <PayStationStatements />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.PayStationStatement,
                                },
                            },
                            {
                                path: 'pay-station-collections/:year/:month',
                                element: <PayStationCollections />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.PayStationCollections,
                                },
                            },

                            {
                                path: 'parkings',

                                children: [
                                    {
                                        path: '',
                                        element: (
                                            <Parkings tab={ParkingsTab.MAP} />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.Parkings,
                                        },
                                        children: parkingsDetailRoutes,
                                    },
                                    {
                                        path: 'list',
                                        element: (
                                            <Parkings tab={ParkingsTab.LIST} />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingsList,
                                        },
                                        children: parkingsDetailRoutes,
                                    },
                                ],
                            },

                            {
                                path: 'recode',
                                children: [
                                    {
                                        path: 'statement',
                                        element: (
                                            <CloudConnectorRecodeStatements />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeStatements,
                                        },
                                    },
                                    {
                                        path: 'auto-recode',
                                        element: <CloudConnectorAutoRecode />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorAutoRecode,
                                        },
                                        children: [
                                            {
                                                path: 'add',
                                                element: (
                                                    <CloudConnectorAutoRecodeCreate />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.CloudConnectorAutoRecodeCreate,
                                                },
                                            },
                                            {
                                                path: ':autoRecodeId/edit',
                                                element: (
                                                    <CloudConnectorAutoRecodeEdit />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.CloudConnectorAutoRecodeEdit,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: 'qr-codes',
                                        element: (
                                            <CloudConnectorRecodeQrCodes />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeQrCodes,
                                        },
                                        children: [
                                            {
                                                path: 'add',
                                                element: (
                                                    <CloudConnectorRecodeQrCodesAdd />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.CloudConnectorRecodeQrCodesAdd,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: 'offstreet-devices',
                                element: <PeripheriesOverviewDesktop />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CloudConnectorPeripheries,
                                },
                                children: offstreetDevicesRoutes,
                            },
                            {
                                path: 'counters',
                                element: <CloudConnectorCounterOverview />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CloudConnectorCounterOverview,
                                },
                                children: [
                                    {
                                        path: ':zoneBarrierGateAreaCounterId',
                                        element: (
                                            <CloudConnectorCounterDetail />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorCounterDetail,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        handle: {
                            title: (
                                <Localized
                                    de="Parkingpay"
                                    fr="Parkingpay"
                                    en="Parkingpay"
                                    it="Parkingpay"
                                />
                            ),
                        },
                        children: [
                            {
                                path: 'clearance-permit-list',
                                element: <ClearancePermitList />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ClearancesPermitsList,
                                },
                            },
                            {
                                path: 'clearance-requests',
                                element: <ClearanceRequests />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ClearanceRequests,
                                },
                            },
                            {
                                path: 'customer-accounts',
                                element: <CustomerAccounts />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CustomerAccounts,
                                },
                            },
                            {
                                path: 'special-reports',
                                element: <SpecialReports />,
                                handle: {
                                    routeName: OperatorAppRoutes.SpecialReports,
                                },
                            },
                            {
                                path: 'permit-types',
                                element: <PermitTypes />,
                                handle: {
                                    routeName: OperatorAppRoutes.PermitTypes,
                                },
                                children: [
                                    {
                                        path: 'quotas/:contractQuotaPartitionId',
                                        element: <OperatorQuotasDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.QuotasDetail,
                                        },
                                        children: [
                                            {
                                                path: 'reduction',
                                                element: (
                                                    <OperatorQuotasReduction />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.QuotasReduction,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: ':permitTypeId',
                                        element: <PermitTypesDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.PermitTypesDetail,
                                        },
                                        children: [
                                            {
                                                path: 'quotas/:contractQuotaPartitionId',
                                                element: (
                                                    <OperatorQuotasDetail />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.QuotasDetail,
                                                },
                                                children: [
                                                    {
                                                        path: 'reduction',
                                                        element: (
                                                            <OperatorQuotasReduction />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.QuotasReduction,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'parkingabo',
                        handle: {
                            title: (
                                <Localized
                                    de="Parkingabo"
                                    fr="Parkingabo"
                                    en="Parkingabo"
                                    it="Parkingabo"
                                />
                            ),
                        },
                        children: [
                            {
                                path: 'users',
                                element: <OperatorParkingaboUsers />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ParkingaboUsers,
                                },
                                children: [
                                    {
                                        path: 'add/role/:roleId',
                                        element: <OperatorParkingaboAddUser />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboUsersAdd,
                                        },
                                    },
                                    {
                                        path: 'invite/role/:roleId',
                                        element: (
                                            <OperatorParkingaboInviteUser />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboUsersInvite,
                                        },
                                    },
                                    {
                                        path: ':customerNr',
                                        element: (
                                            <OperatorParkingaboUsersDetails />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboUsersDetail,
                                        },
                                        children: [
                                            {
                                                path: 'detail',
                                                element: (
                                                    <OperatorParkingaboUserEditForm />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.ParkingaboUsersDetail,
                                                },
                                            },
                                            {
                                                path: 'products',
                                                element: (
                                                    <OperatorParkingaboUsersProducts />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.ParkingaboUsersProducts,
                                                },
                                                children: [
                                                    {
                                                        path: 'add',
                                                        element: (
                                                            <OperatorParkingaboUsersProductsAdd />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.ParkingaboUsersProductsAdd,
                                                        },
                                                    },
                                                    {
                                                        path: ':contractExternalId/detail',
                                                        element: (
                                                            <OperatorParkingaboUserProductDetail />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.ParkingaboUsersProductsDetail,
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                path: 'transactions',
                                                element: (
                                                    <OperatorParkingaboUsersTransactions />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.ParkingaboUsersTransactions,
                                                },
                                                children: [
                                                    ...offstreetTransactionsDetailRoutes,
                                                    {
                                                        path: 'no-access',
                                                        element: (
                                                            <NoAccessDialogRoute />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.CloudConnectorRecodeSuccessResponse,
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                path: 'vehicles',
                                                element: (
                                                    <OperatorParkingaboUsersVehicles />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.ParkingaboUsersVehicles,
                                                },
                                                children: [
                                                    {
                                                        path: 'add',
                                                        element: (
                                                            <OperatorParkingaboUsersVehicleAddForm />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.ParkingaboUsersVehiclesAdd,
                                                        },
                                                    },
                                                    {
                                                        path: ':vehicleId',
                                                        element: (
                                                            <OperatorParkingaboUsersVehicleEditForm />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.ParkingaboUsersVehiclesDetail,
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                path: 'account-statement',
                                                element: (
                                                    <OperatorParkingaboUsersAccountStatement />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.ParkingaboUsersAccountStatement,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },

                            {
                                path: 'products',
                                element: <OperatorProducts />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ParkingaboProducts,
                                },
                                children: [
                                    {
                                        path: ':contractExternalId/detail',
                                        element: <OperatorProductDetail />,
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboProductsDetail,
                                        },
                                    },
                                ],
                            },

                            {
                                path: 'roles',
                                element: <OperatorParkingaboRoles />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ParkingaboRoles,
                                },
                            },

                            {
                                path: 'product-types',
                                element: <OperatorProductTypes />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.ParkingaboProductTypes,
                                },
                                children: [
                                    {
                                        path: ':contractTemplateId/detail',
                                        element: (
                                            <OperatorProductTypesDetailModal />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.ParkingaboProductTypesDetail,
                                        },
                                        children: [
                                            {
                                                path: 'quotas/:contractQuotaPartitionId',
                                                element: (
                                                    <OperatorQuotasDetail />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.QuotasDetail,
                                                },
                                                children: [
                                                    {
                                                        path: 'reduction',
                                                        element: (
                                                            <OperatorQuotasReduction />
                                                        ),
                                                        handle: {
                                                            routeName:
                                                                OperatorAppRoutes.QuotasReduction,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        handle: {
                            title: (
                                <Localized
                                    de="Externe Module"
                                    fr="Modules externes"
                                    en="External Modules"
                                    it="Moduli esterni"
                                />
                            ),
                        },
                        children: [
                            {
                                path: 'parkmonitor',
                                element: (
                                    <IframeComponent
                                        url={(lng: string) =>
                                            `https://parkmonitor.parkingportal.ch/PUBLIC/?langue=${parkmonitorLanguages[lng]}`
                                        }
                                    />
                                ),
                                handle: {
                                    routeName: OperatorAppRoutes.Parkmonitor,
                                },
                            },
                            {
                                path: 'mi-office',
                                element: (
                                    <IframeComponent
                                        url={() =>
                                            'https://mioffice.parkingportal.ch//mioffice_taxomex/Account/Login'
                                        }
                                    />
                                ),
                                handle: {
                                    routeName: OperatorAppRoutes.MiOffice,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'mobile',
                element: <MobileLayout />,
                handle: {
                    isMobile: true,
                },
                children: [
                    {
                        index: true,
                        element: <MobileHomePage />,
                        handle: {
                            routeName: OperatorAppRoutes.MobileHomePage,
                        },
                    },
                    {
                        path: 'offstreet-devices',
                        element: <PeripheriesOverviewMobile />,
                        handle: {
                            routeName:
                                OperatorAppRoutes.MobileCloudConnectorPeripheries,
                        },
                        children: offstreetDevicesRoutes,
                    },
                    {
                        path: 'counter',
                        element: <CloudConnectorCounterOverview mobile />,
                        handle: {
                            routeName:
                                OperatorAppRoutes.MobileCloudCounterOverview,
                        },
                        children: [
                            {
                                path: ':zoneBarrierGateAreaCounterId',
                                element: <CloudConnectorCounterDetail mobile />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.MobileCloudCounterDetail,
                                },
                            },
                        ],
                    },
                    {
                        path: 'recode',
                        element: <CloudConnectorRecoder />,
                        handle: {
                            routeName: OperatorAppRoutes.CloudConnectorRecode,
                        },
                        children: [
                            {
                                path: 'success',
                                element: (
                                    <CloudConnectorRecodeSuccessResponse />
                                ),
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CloudConnectorRecodeSuccessResponse,
                                },
                            },
                            {
                                path: 'error/:type?',
                                element: <CloudConnectorRecodeErrorResponse />,
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CloudConnectorRecodeErrorResponse,
                                },
                            },
                            {
                                path: 'ticketScan/:ticketScan',
                                element: (
                                    <CloudConnectorRecodeTicketScanConditionsOutlet />
                                ),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <CloudConnectorRecodeEntryWithoutExit />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExit,
                                        },
                                    },
                                    {
                                        path: 'recodeCondition/:recodeConditionId',
                                        element: (
                                            <CloudConnectorRecodeEntryWithoutExitCondition />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExitCondition,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'ticketScanQr/:ticketId',
                                element: (
                                    <CloudConnectorRecodeTicketScanQrConditionsOutlet />
                                ),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <CloudConnectorRecodeEntryWithoutExit />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExit,
                                        },
                                    },
                                    {
                                        path: 'recodeCondition/:recodeConditionId',
                                        element: (
                                            <CloudConnectorRecodeEntryWithoutExitCondition />
                                        ),
                                        handle: {
                                            routeName:
                                                OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExitCondition,
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'licensePlateSearch',
                                element: (
                                    <CloudConnectorRecodeLicensePlateSerach />
                                ),
                                handle: {
                                    routeName:
                                        OperatorAppRoutes.CloudConnectorRecodeLicsenPlateSerach,
                                },
                                children: [
                                    {
                                        path: 'licensePlateNr/:licensePlateNr',
                                        element: (
                                            <CloudConnectorRecodeLicensePlateConditions />
                                        ),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <CloudConnectorRecodeEntryWithoutExit />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExit,
                                                },
                                            },
                                            {
                                                path: 'recodeCondition/:recodeConditionId',
                                                element: (
                                                    <CloudConnectorRecodeEntryWithoutExitCondition />
                                                ),
                                                handle: {
                                                    routeName:
                                                        OperatorAppRoutes.CloudConnectorRecodeEntryWithoutExitCondition,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'settings',
                        element: <ParkingPortalSettings />,
                        handle: {
                            routeName:
                                OperatorAppRoutes.MobileCloudConnectorSettings,
                        },
                    },
                    {
                        path: '*',
                        element: <Navigate to=".." replace={true} />,
                        handle: {
                            routeName: OperatorAppRoutes.MobileHomePage,
                        },
                    },
                ],
            },
            {
                path: 'privacy',
                element: <ParkingportalPrivacy />,
                handle: {
                    routeName: OperatorAppRoutes.Privacy,
                },
            },
        ],
    };
}

export function App({ allState }: { allState: Flux.Store }) {
    return (
        <div className={css({ fontFamily: 'Roboto', height: '100%' })}>
            <Flux.StoreContext.Provider value={allState}>
                <OperatorLanguageProvider>
                    <OperatorThemeProvider>
                        <CssBaseline>
                            <OperatourRouterProvider />
                        </CssBaseline>
                    </OperatorThemeProvider>
                </OperatorLanguageProvider>
            </Flux.StoreContext.Provider>
        </div>
    );
}

function OperatorLanguageProvider({ children }: { children: ReactNode }) {
    const { storeState, update } = useStore(
        store => new StateSlice(store).state,
    );

    const context = useMemo(() => {
        return {
            language: languageFromString(storeState.language),
            setLanguage: (language: Language) => {
                update(store => {
                    new SettingsState.StateSlice(store).writeLanguage(language);
                    return 'update-operator-language';
                });
            },
        };
    }, [storeState.language, update]);

    return <LanguageProvider context={context}>{children}</LanguageProvider>;
}

const parkmonitorLanguages: { [key: string]: string } = {
    de: 'ger',
    fr: 'fre',
    it: 'ita',
};

const IframeComponent = Flux.selectState<
    { url: (lng: string) => string },
    { settings: SettingsState.State }
>(
    store => ({
        settings: new SettingsState.StateSlice(store).state,
    }),
    p => {
        return <IFrame url={p.url} language={p.settings.language} />;
    },
);
